// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__4943r","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__6BG9R"};